import React, { useEffect, useState } from 'react';
import styles from './FloorplanContent.module.scss';
import Carousel from 'react-material-ui-carousel';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import { connect } from 'react-redux';
import {
	getOptionDetails,
	loadFloorplanImgs,
} from '../../../../../../redux/agreement/actions';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';

const FloorplanContent = ({
	floorplanImages,
	loadFloorplanImgs,
	modelName,
	elevation,
	getOptionDetails,
}) => {
	const [hover, setHover] = useState('');
	const [openImage, setOpenImage] = useState(false);
	const [photoIndex, setPhotoIndex] = useState(0);
	var imagesArr = [];
	useEffect(() => {
		if (floorplanImages.length === 0) {
			loadFloorplanImgs(modelName, elevation?.toLowerCase());
			getOptionDetails(modelName, elevation);
		}
	}, []);
	// var plans = [
	// 	'https://via.placeholder.com/599x300',
	// 	'https://via.placeholder.com/890x234',
	// 	'https://via.placeholder.com/599x900',
	// 	'https://via.placeholder.com/599x354',
	// 	'https://via.placeholder.com/599x200',
	// 	'https://via.placeholder.com/599x500',
	// 	'https://via.placeholder.com/599x124',
	// ];

	// const rows = plans.reduce(function (rows, key, index) {
	// 	return (
	// 		(index % 2 == 0
	// 			? rows.push([key])
	// 			: rows[rows.length - 1].push(key)) && rows
	// 	);
	// }, []);

	const chunk = (arr, chunkSize) => {
		const res = [];
		for (let i = 0; i < arr?.length; i += chunkSize) {
			const chunk = arr.slice(i, i + chunkSize);
			res.push(chunk);
		}
		return res;
	};

	const newArray = chunk(floorplanImages, 2).reduce((acc, item) => {
		return [...acc, { items: item.map((i) => ({ image: i })) }];
	}, []);

	const styleHover = (id) => {
		if (Number(id) === Number(hover?.index)) {
			return { display: 'block' };
		}
	};

	console.log('new Array', newArray, newArray.length);

	return (
		<div className={styles.floorplanContentWrapper}>
			<div className={styles.title}>Review Floor Plan</div>
			<div className={styles.content}>
				<Carousel
					autoPlay={false}
					className={styles.carousel}
					navButtonsAlwaysInvisible={
						newArray.length > 0 ? true : false
					}
					navButtonsProps={{
						style: {
							backgroundColor: 'var(--primary)',
						},
						className: 'navigation',
						'aria-label': 'button-wrapper',
					}}
					fullHeightHover
					navButtonsWrapperProps={{
						className: 'navButtonWrapper',
					}}
					activeIndicatorIconButtonProps={{
						style: {
							color: 'var(--primary-hover)',
						},
					}}
					indicatorIconButtonProps={{
						style: {
							color: 'var(--primary-label)',
						},
						'aria-label': 'indicator-icon',
					}}
				>
					{newArray.map((item) =>
						item.items.map((image, index) => {
							imagesArr.push(image.image);
							return (
								<div
									className={styles.floorplanItem}
									onMouseEnter={() =>
										setHover({ ...hover, index: index })
									}
									onMouseLeave={() => setHover()}
									onClick={() => {
										setOpenImage(true);
										setPhotoIndex(index);
									}}
								>
									<img src={image.image} alt='test' />

									<div
										className={styles.layout}
										data-index={index}
										style={{
											...styleHover(index),
										}}
									></div>
									<div className={styles.zoomIcon}>
										<ZoomInIcon />
									</div>
								</div>
							);
						})
					)}
				</Carousel>

				{openImage && (
					<Lightbox
						mainSrc={floorplanImages[photoIndex]}
						nextSrc={
							floorplanImages[
								(photoIndex + 1) % floorplanImages.length
							]
						}
						prevSrc={
							floorplanImages[
								(photoIndex + floorplanImages.length - 1) %
									floorplanImages.length
							]
						}
						onCloseRequest={() => setOpenImage(false)}
						onMovePrevRequest={() =>
							setPhotoIndex(
								(photoIndex + floorplanImages.length - 1) %
									floorplanImages.length
							)
						}
						onMoveNextRequest={() =>
							setPhotoIndex(
								(photoIndex + 1) % floorplanImages.length
							)
						}
					/>
				)}
			</div>
		</div>
	);
};

const mapStateToProps = (state) => ({
	floorplanImages: state.agreement.floorplansImages,
	modelName:
		state.agreement.productAvailability.modelName ||
		state.agreement.agreementById?.productAvailability?.modelName,
	elevation:
		state.agreement.productAvailability.elevation?.id ||
		state.agreement.agreementById?.productAvailability?.elevation?.id,
});

export default connect(mapStateToProps, {
	loadFloorplanImgs,
	getOptionDetails,
})(FloorplanContent);
